import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';
import NumericWithNullEntry from '../../atoms/Input/NumericWithNullEntry';
import NumericEntry_inputEx from './../../atoms/Input/NumericEntry_inputEx';

type CreateGroupDialogProps = {
  dialog: DialogAction<CreateGroupDialogResponse>;
  /** 登録済みグループ*/
  exists: number[] | undefined;
  maxGroup: number;
};

export type CreateGroupDialogResponse = {
  no: number;
};

const useStyles = makeStyles(
  createStyles({
    button: {
      width: '150px',
    },
    title: {
      width: '150px',
    },
    error: {
      color: 'red',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      backgroundcolor: 'transparent',
      borderBottom: '1px solid #000000',
      borderTop: 'none',
      borderLeft:'none',
      borderRight:'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
  })
);

const checkOutOfRange = (gno: number, max: number): boolean => {
  return gno > 0 && gno <= max;
}


/**
 * グループに登録可能な場合は１～１２８のグループ番号を返却
 * @param props 
 * @returns 
 */
const CreateGroupDialog: React.FC<CreateGroupDialogProps> = (props: CreateGroupDialogProps) => {
  //console.debug("CreateGroupDialog()", props);

  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [no, setNo] = useState<number>(0);
  const [message, setMessage] = useState<string>('');
  const [btnEnable, setBtnEnable] = useState<boolean>(true);

  const validateNo = () => {
    console.debug(`validateNo(), no:${no}, exists:${props.exists}`);

    if (props.exists) {
      //既にグループが存在する
      if (props.exists.findIndex((grp) => grp === no) < 0) {
        if (checkOutOfRange(no, props.maxGroup)) {
          setMessage('');
          return true;
        }
        setMessage(t('CreateGroupDialog.範囲外です', '範囲外です'));
      } else {
        setMessage(t('CreateGroupDialog.既に存在するグループです', '既に存在するグループです'));
      }
    } else {
      //未登録グループ
      if (checkOutOfRange(no, props.maxGroup)) {
        setMessage('');
        return true;
      }
      setMessage(t('CreateGroupDialog.範囲外です', '範囲外です'));
    }
    return false;
  };

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onEntered={(e) => { }}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({
              no: no,
            });
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{t('CreateGroupDialog.新規グループ作成', '新規グループ作成')}</DialogTitle>
        <DialogContent>
          <Table>
            <TableContainer>
              <TableHead>
                <TableRow>
                  <TableCell>{t('CreateGroupDialog.グループ番号', 'グループ番号')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    {/* <NumericWithNullEntry value={no} fixed={0} maxLen={4} isTextAlignRight={true}
                      onChange={(e) => {
                        console.debug('onChange -- e', e);
                        if (e != undefined && !isNaN(e)) {
                          setNo(e);
                        } else {
                          setNo(0);
                        }
                      }} /><br />
                    <span className={classes.error}>{message}</span> */}
                    <NumericEntry_inputEx className={classes.textField} value={no} fixed={0}
                      maxValueLimit={9999} 
                      minValueLimit={0}
                      onChange={(e) => {
                        console.debug('onChange -- e', e);
                        if (e != undefined && !isNaN(e)) {
                          setNo(e);
                        } else {
                          setNo(0);
                        }
                      }} /><br />
                    <span className={classes.error}>{message}</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableContainer>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            disabled={!btnEnable}
            onClick={(e) => {
              if (validateNo()) {
                setIsOpen(false);
                setMode(true);
              }
            }}
          >
            {t('CreateGroupDialog.作成', '作成')}
          </Button>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={(e) => {
              setIsOpen(false);
              setMode(false);
            }}
          >
            {t('CreateGroupDialog.キャンセル', 'キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateGroupDialog;
